export type EmojiOption = {
  emoji: string;
  label: string;
};

// curated list - includes all emoji actively used in production site names
export const emojiOptions: EmojiOption[] = [
  // water and weather
  { emoji: "💧", label: "water drop" },
  { emoji: "💦", label: "sweat drops" },
  { emoji: "🌊", label: "wave" },
  { emoji: "🚰", label: "tap water" },
  { emoji: "🚽", label: "toilet" },
  { emoji: "🧊", label: "ice" },
  { emoji: "🌧️", label: "rain" },
  { emoji: "⛈️", label: "storm" },
  { emoji: "🌦️", label: "sun and rain" },
  { emoji: "❄️", label: "snowflake" },
  { emoji: "🌀", label: "cyclone" },
  { emoji: "☀️", label: "sun" },
  { emoji: "🌑", label: "moon" },
  { emoji: "💨", label: "wind" },
  { emoji: "🌅", label: "sunrise" },
  { emoji: "🌤️", label: "sun behind cloud" },
  { emoji: "🫗", label: "pouring liquid" },

  // environment and nature
  { emoji: "🌿", label: "herb" },
  { emoji: "🌱", label: "seedling" },
  { emoji: "🌳", label: "tree" },
  { emoji: "🍃", label: "leaf" },
  { emoji: "🍀", label: "clover" },
  { emoji: "🌎", label: "earth americas" },
  { emoji: "🌏", label: "earth asia" },
  { emoji: "🏞️", label: "national park" },
  { emoji: "♻️", label: "recycle" },
  { emoji: "🐟", label: "fish" },
  { emoji: "🐚", label: "shell" },
  { emoji: "🐒", label: "monkey" },
  { emoji: "🦖", label: "dinosaur" },
  { emoji: "🐝", label: "bee" },
  { emoji: "🦅", label: "eagle" },
  { emoji: "🦊", label: "fox" },
  { emoji: "🥑", label: "avocado" },
  { emoji: "🪷", label: "lotus" },

  // industry and infrastructure
  { emoji: "🏭", label: "factory" },
  { emoji: "🏗️", label: "construction" },
  { emoji: "🚧", label: "construction sign" },
  { emoji: "⚙️", label: "gear" },
  { emoji: "🔧", label: "wrench" },
  { emoji: "🦾", label: "mechanical arm" },
  { emoji: "🏢", label: "building" },
  { emoji: "🏠", label: "house" },
  { emoji: "🏫", label: "school" },
  { emoji: "🏥", label: "hospital" },
  { emoji: "🔗", label: "link" },
  { emoji: "💻", label: "computer" },
  { emoji: "🕸️", label: "web" },
  { emoji: "🖥️", label: "desktop computer" },
  { emoji: "🛢️", label: "oil drum" },
  { emoji: "🔒", label: "lock" },

  // science and measurement
  { emoji: "🔬", label: "microscope" },
  { emoji: "🧪", label: "test tube" },
  { emoji: "⚗️", label: "alembic" },
  { emoji: "📊", label: "chart" },
  { emoji: "📈", label: "graph up" },
  { emoji: "🧫", label: "petri dish" },
  { emoji: "🌡️", label: "thermometer" },
  { emoji: "⚖️", label: "scale" },
  { emoji: "📡", label: "satellite dish" },
  { emoji: "⏳", label: "hourglass" },
  { emoji: "🕒", label: "clock three" },
  { emoji: "🕖", label: "clock seven" },

  // alerts and status
  { emoji: "⚠️", label: "warning" },
  { emoji: "✅", label: "check" },
  { emoji: "🚨", label: "alert" },
  { emoji: "🛑", label: "stop sign" },
  { emoji: "⛔", label: "no entry" },
  { emoji: "🔴", label: "red circle" },
  { emoji: "🟢", label: "green circle" },
  { emoji: "🟡", label: "yellow circle" },
  { emoji: "🔵", label: "blue circle" },
  { emoji: "🟠", label: "orange circle" },
  { emoji: "🟣", label: "purple circle" },
  { emoji: "🆕", label: "new" },
  { emoji: "‼️", label: "double exclamation" },
  { emoji: "ℹ️", label: "info" },
  { emoji: "⚡", label: "lightning" },
  { emoji: "✔️", label: "check mark" },
  { emoji: "❓", label: "question mark" },
  { emoji: "➡️", label: "right arrow" },
  { emoji: "➕", label: "plus" },
  { emoji: "✳️", label: "eight spoked asterisk" },
  { emoji: "⭕", label: "hollow red circle" },
  { emoji: "🚫", label: "prohibited" },
  { emoji: "🟦", label: "blue square" },
  { emoji: "🔸", label: "small orange diamond" },
  { emoji: "🔹", label: "small blue diamond" },
  { emoji: "🔷", label: "large blue diamond" },

  // transport and vehicles
  { emoji: "🚀", label: "rocket" },
  { emoji: "🛩️", label: "airplane" },
  { emoji: "🚋", label: "tram" },
  { emoji: "🚐", label: "minibus" },
  { emoji: "🚙", label: "car" },
  { emoji: "🚛", label: "truck" },
  { emoji: "🏎️", label: "race car" },
  { emoji: "🏍️", label: "motorcycle" },
  { emoji: "🛣️", label: "road" },
  { emoji: "🚚", label: "delivery truck" },
  { emoji: "🛻", label: "pickup truck" },
  { emoji: "🚗", label: "automobile" },

  // people and activities
  { emoji: "👀", label: "eyes" },
  { emoji: "👷‍♂️", label: "construction worker" },
  { emoji: "🏋️‍♀️", label: "weightlifter female" },
  { emoji: "🏋️‍♂️", label: "weightlifter male" },
  { emoji: "🤽‍♂️", label: "water polo" },
  { emoji: "🤠", label: "cowboy" },
  { emoji: "👽", label: "alien" },
  { emoji: "👾", label: "space invader" },
  { emoji: "🎓", label: "graduation" },
  { emoji: "🥾", label: "hiking boot" },
  { emoji: "🩴", label: "flip flop" },
  { emoji: "🪂", label: "parachute" },
  { emoji: "⛸️", label: "ice skate" },
  { emoji: "⚓", label: "anchor" },
  { emoji: "👮", label: "police officer" },
  { emoji: "😎", label: "sunglasses face" },
  { emoji: "😷", label: "mask face" },
  { emoji: "🤔", label: "thinking face" },
  { emoji: "🧙‍♂️", label: "wizard" },
  { emoji: "💪", label: "flexed bicep" },
  { emoji: "👁️", label: "eye" },
  { emoji: "💋", label: "kiss mark" },
  { emoji: "🎩", label: "top hat" },

  // safety and ppe
  { emoji: "☠️", label: "skull crossbones" },
  { emoji: "🦺", label: "safety vest" },
  { emoji: "🥽", label: "goggles" },
  { emoji: "🧤", label: "gloves" },
  { emoji: "🛟", label: "ring buoy" },

  // general utility
  { emoji: "⭐", label: "star" },
  { emoji: "🔥", label: "fire" },
  { emoji: "💡", label: "lightbulb" },
  { emoji: "📍", label: "pin" },
  { emoji: "🏷️", label: "tag" },
  { emoji: "📋", label: "clipboard" },
  { emoji: "📰", label: "newspaper" },
  { emoji: "📦", label: "package" },
  { emoji: "🪙", label: "coin" },
  { emoji: "🔑", label: "key" },
  { emoji: "🛠️", label: "tools" },
  { emoji: "💩", label: "poop" },
  { emoji: "⌚", label: "watch" },
  { emoji: "📷", label: "camera" },
  { emoji: "📸", label: "camera flash" },
  { emoji: "✏️", label: "pencil" },
  { emoji: "📝", label: "memo" },
  { emoji: "📗", label: "green book" },
  { emoji: "📘", label: "blue book" },
  { emoji: "📕", label: "red book" },
  { emoji: "📙", label: "orange book" },
  { emoji: "📔", label: "notebook" },
  { emoji: "📜", label: "scroll" },
  { emoji: "💜", label: "purple heart" },
  { emoji: "🧂", label: "salt" },
  { emoji: "🧨", label: "firecracker" },
  { emoji: "🧽", label: "sponge" },
  { emoji: "🪣", label: "bucket" },
  { emoji: "🪥", label: "toothbrush" },
  { emoji: "🦷", label: "tooth" },
  { emoji: "🥇", label: "gold medal" },
  { emoji: "🥈", label: "silver medal" },
  { emoji: "🥃", label: "tumbler glass" },
  { emoji: "🍕", label: "pizza" },
  { emoji: "🍰", label: "cake" },
  { emoji: "🎲", label: "dice" },
  { emoji: "🔎", label: "magnifying glass" },
];
